<template>
    <!-- Render the current node -->
    <li 
        v-if="!isHidden"
        v-bind="{
            id : node.id,
            class : { 
                [nodeTypeClass] : true, 
                ['sel_' + nodeTypeClass] : active            
            },
            style : { 
//                background : utils.labelColor(node.layout.label, GET_usedLabels) 
            }
        }"
        @click.stop="handleClick()"
    >
        <div :id="node.id + '_color'"
            v-if="(node.layout.type == gConsts.node.layout.types.LABEL)"
            :style="{
                display    : 'inline-block',
                width      : '14px',
                height     : '14px',
                background : node.layout.color,
                marginRight : '10px'
            }">
        </div>

        <span 
            v-html="(node.layout.type == gConsts.node.layout.types.LABEL) ? highlightMatches(node.layout.caption) : node.layout.caption"
            :id="node.id + '_text'"
        ></span>
        <span :id="node.id + '_locations'">
            {{ labelLocations.length > 0 ? '- ' + labelLocations.join(', ') : '' }}
        </span>

        <Transition name="nodeTransition">
            <template v-if="hasChildren && (active || (GET_nodeSearchStr != '') || displayExpanded)">
                <!-- Check if the node is of a generic type -->
                <template v-if="isGenericNode">
                    <ul>
                        <nodeCMP 
                            v-for="child in children" :key="child.id"
                                :node="child"
                                :id="node.id"
                        />                                                
                    </ul>
                </template>

                <!-- Check if the node is of a specialized type -->
                <component v-else 
                    :is   = "getSpecializedLayerCMP" 
                    :node = "node"
                    :id   = "node.id"
                    :children = "children"
                ></component>
            </template>            
        </Transition>
    </li>
</template>


<script>
import nodeCMP             from './node.vue';
import layerSelectCMP      from './layerSelect.vue';
import layerRadioGroupCMP  from './layerRadioGroup.vue';
import layerOdontogramaCMP from './layerOdontograma.vue';

import { gConsts } from '@/globals/gConsts';
import { utils   } from '@/globals/utils';
import { nodes   } from '@/globals/nodes';

import { mapGetters, mapState, mapActions } from 'vuex';

export default {
    name : 'nodeCMP',
    components : {
        nodeCMP,
        layerSelectCMP,
        layerRadioGroupCMP,
        layerOdontogramaCMP
    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    props: {
        node: {
            type: Object,
            required: true
        },
        filteredChildren: {
            type: Array,
            default: () => []
        },
        id : { type : String },
    },


    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    data () {
        return {
            gConsts : gConsts,
            utils   : utils,
            labelLocations : [],
        }
    },

    watch: {

        // Watch reportNodeData with deep watching to detect nested property changes
        // (like locations and reportText modifications in the store)
        reportNodeData: {
            handler(newVal, oldVal) {
                console.log('reportNodeData update detected for node:', this.node.id, {
                    locations: newVal?.locations,
                    reportText: newVal?.reportText,
                    fullData: newVal
                });
                
                // if (newVal && newVal.locations && newVal.locations.length > 0) {
                //     this.labelLocations = newVal.locations.map(location => location.label);
                // } else {
                //     this.labelLocations = [];
                // }
            },
            immediate: true,
            deep: true
        },

        // Also watch GET_reportNodes to catch when the array reference changes
        // or when reportNodes are added/removed
        GET_reportNodes: {
            handler(newReportNodes) {
                // const reportNode = newReportNodes.find(reportNode => reportNode.id == this.node.id);
                // // Only update if reportNode exists and has changed
                // // This catches cases where the array reference changes but the computed property might not trigger
                // if (reportNode) {
                //     if (reportNode.location.list && reportNode.location.list.length > 0) {
                //         const newLocations = reportNode.location.list.map(location => location.label);
                //         // Only update if locations actually changed to avoid unnecessary updates
                //         if (JSON.stringify(newLocations) !== JSON.stringify(this.labelLocations)) {
                //             this.labelLocations = newLocations;
                //         }
                //     } else if (this.labelLocations.length > 0) {
                //         this.labelLocations = [];
                //     }
                // } else if (this.labelLocations.length > 0) {
                //     // ReportNode was removed
                //     this.labelLocations = [];
                // }
            },
            deep: true
        }
    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    computed: {
        ...mapState([
        ]),

        // -----------------------------------------------------------------

        ...mapGetters([
            'GET_usedLabels',
            'GET_filteredNodes',
            'GET_activeNodes',
            'GET_nodeSearchStr',
            'GET_execModeVIEW',
            'GET_reportNodes'
        ]),

        // -----------------------------------------------------------------

        children() { 
            return this.GET_filteredNodes.filter(node => (node.layout.parent === this.node.id));
        },
        hasChildren() { return this.children.length > 0; },

        // -----------------------------------------------------------------
        
        parent() {
            return nodes.getNode(this.node.layout.parent);
        },

        // -----------------------------------------------------------------

        displayExpanded() {            
            return ( ((this.node.layout.type == gConsts.node.layout.types.LAYER) && (this.parent.layout.expanded == true)) || this.GET_execModeVIEW );
        },

        // -----------------------------------------------------------------

        active() { return this.GET_activeNodes?.has(this.node.id) },

        // -----------------------------------------------------------------

        nodeTypeClass() { return `node-type-${this.node.layout.type}` },

        // -----------------------------------------------------------------

        isSpecializedLayer() {
            var specilizedLayers = [
                gConsts.node.layout.groups.SELECT,
                gConsts.node.layout.groups.RADIO_GROUP, 
                gConsts.node.layout.groups.ODONTG
            ];
            
            return (this.node.layout.type == gConsts.node.layout.types.LAYER) && specilizedLayers.includes(this.node.layout.group);
        },

        // -----------------------------------------------------------------

        isGenericNode() { return !this.isSpecializedLayer; },

        // -----------------------------------------------------------------

        // node or parent is node.layout.group.HIDDEN
        isHidden() {
            return (this.node.layout.group == gConsts.node.layout.groups.HIDDEN                     ) || 
                   ((this.parent) && (this.parent.layout.group == gConsts.node.layout.groups.HIDDEN));
        },

        // -----------------------------------------------------------------

        getSpecializedLayerCMP() {
            var compName = '';

            switch (this.node.layout.group) {
                case gConsts.node.layout.groups.RADIO_GROUP : compName = 'layerRadioGroupCMP' ; break;
                case gConsts.node.layout.groups.ODONTG      : compName = 'layerOdontogramaCMP'; break;
            }

            return compName;
        },

        // -----------------------------------------------------------------

        reportNodeData() {
            return this.GET_reportNodes.find(reportNode => reportNode.nodeId == this.node.id) || null;
        }
        

    },

    // -----------------------------------------------------------------
    // -----------------------------------------------------------------

    methods: {
        ...mapActions([
        ]),

        // -----------------------------------------------------------------

        handleClick() { nodes.activateNode(this.node, this.GET_filteredNodes); },

        // -----------------------------------------------------------------

        highlightMatches(caption) {
            if (!this.GET_nodeSearchStr.trim()) {
                return caption;
            }

            // Normalize the caption for diacritic-insensitive comparison
            const normalizedCaption = caption.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

            // Split search terms, normalize them, and escape for regex
            const searchTokens = this.GET_nodeSearchStr
                .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
                .trim()
                .split(/\s+/)
                .map(token => token.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'));

            // Create a regex pattern to match each token at the start of a word boundary
            const regexPattern = searchTokens.map(token => `(${token})`).join('|');
            const regex = new RegExp(`(\\b${regexPattern})`, 'gi');

            // Find all matches and their indices
            let match;
            const matches = [];
            while ((match = regex.exec(normalizedCaption)) !== null) {
                matches.push({ index: match.index, length: match[0].length });
            }

            // Reconstruct the original caption with highlights
            let highlightedCaption = '';
            let currentPosition = 0;
            matches.forEach(match => {
                // Add the text before the match
                highlightedCaption += caption.slice(currentPosition, match.index);
                // Add the highlighted match
                const originalText = caption.slice(match.index, match.index + match.length);
                highlightedCaption += `<span class="highlightCaption">${originalText}</span>`;
                currentPosition = match.index + match.length;
            });

            // Add any remaining text after the last match
            highlightedCaption += caption.slice(currentPosition);

            return highlightedCaption;
        }
    },
}

</script>

// =========================================================================================
// =========================================================================================

<style>
li {
    position: relative;
    text-align: left;
    font-family: Verdana;
    max-width: 95%;
    font-weight: normal;
    margin: 1px;
    word-wrap: break-word;
    white-space: normal;
}


ul {
    list-style: none;
    padding-left:0px;
    margin-top: 0px;
    position: relative;
    height: auto;
    top: 0px;
    left: 0px;
    overflow: visible;
}


.node-type-step {
    list-style:disc;
    font-size: 1.5em;
    margin-left:10px;
}

.node-type-step:not(:first-child) {
    margin-top: 10px;
}

.sel_node-type-step {
    outline: 1px solid lightgray;
    background: rgb(247, 254, 247)
}

.node-type-layer {
    font-size: 0.8em;
    left: 15px;
    margin-top: 5px;
}

.node-type-layer:not(:first-child) {
    margin-top: 20px;    
    border-top: 1px solid lightgray;
    padding-top: 5px;
}

.sel_node-type-layer {
    background: rgb(230, 251, 230)
}

.node-type-lb {
    font-size: 0.8em;
    left: 25px;
    margin-left: 5px;
    margin-top: 4px;
}

.node-type-lb:first-child {
    margin-top: 5px;
}

.sel_node-type-lb {
    outline: 1px solid lightgray;
    background: lightgreen;
}


/*
.node-type-qualifier {
}
*/
    
.nodeTransition-enter-active {
    transition: opacity 0.2s ease-in;
}

.nodeTransition-leave-active {
    transition: opacity 0s;
}

.nodeTransition-enter-to, .step-leave {
    opacity: 1;
}

.nodeTransition-enter, .nodeTransition-leave-to {
    opacity: 0;
}

.highlightCaption {
    background-color: lightblue; /* Choose the color that suits your design */
}

</style>